import AllocationInviteService from '@/Network/Services/AllocationInviteService'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'
import {
  buildStationPendingNotice,
  PENDING_CHECK_FAILED_NOTICE
} from '@/modules/company/Dashboard/modals/managementDoctor/inviteWizard'

/**
 * Aviso antes de editar ou excluir um plantão com troca ou convite pendente (acceptance-terms
 * D8/D54d, CA-11). A gravação cancela o pendente no backend de qualquer forma (cascata D54);
 * aqui só se avisa antes, com a mesma fonte do modal de convite (`pending-commitments`).
 *
 * Flag `enabledAllocationInvite` desligada: devolve `null` sem chamada nenhuma (modal de hoje).
 */
export function useStationPendingNotice() {
  const { flags } = useFeatureFlags()
  const allocationInviteService = new AllocationInviteService()

  /** Texto do aviso, ou `null` quando não há o que avisar. Nunca lança. */
  async function fetchNotice(stationId: number): Promise<string | null> {
    if (flags.enabledAllocationInvite !== true) return null
    try {
      const pending = await allocationInviteService.pendingCommitments([stationId])
      return buildStationPendingNotice(pending)
    } catch (error) {
      // fallback intencional (mesmo padrão do modal de convite): o aviso é informativo e a
      // cascata do backend cancela o pendente de qualquer forma; a falha vira o aviso genérico
      // (visível ao usuário) e não bloqueia a ação.
      console.error(error)
      return PENDING_CHECK_FAILED_NOTICE
    }
  }

  return { fetchNotice }
}
